import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "value", "index"];
import { Box } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Tab panel component.
 *
 * @author Ihar Kazlouski
 * @function CustomTabPanel
 * @category components
 * @return {FC} tab panel component.
 */
var CustomTabPanel = function CustomTabPanel(_ref) {
  var children = _ref.children,
      value = _ref.value,
      index = _ref.index,
      other = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Box, {
    hidden: value !== index,
    children: /*#__PURE__*/_jsx(Box, {
      children: children
    })
  });
};

export { CustomTabPanel };